import React, { useEffect, useState } from 'react'


import { deleteUser, loadAudience } from '../utils/Network'
import { Link } from 'react-router-dom';
export default function AudienceContent({ page }) {

    const query = new URLSearchParams(window.location.search);
    var is_verified  =query.get('is_verified') ?? 1
    var filter_ip  =query.get('ip')

    

    if (!page)
        page = 1;
    const [loading, setLoading] = useState(0);

    const [users, setUsers] = useState(null);
    const [next, setNext] = useState(null);
    const [previous, setPrevious] = useState(null);
    const [pages, setPages] = useState(null);
    const [count, setCount] = useState(null);
    const [not_verified_count, setNotVerifiedCount] = useState(false);
    const [show_delete, setShowDelete] = useState(false);
    const [filtered, setFiltered] = useState(false);
    
    
    useEffect(() => {
        if(filter_ip || query.get('is_verified'))
            setFiltered(true)

        loadAudience(page,filter_ip,is_verified).then(data => {
            
            if(is_verified)
                setCount(data.count)
            var page_count = parseInt(data.count / 50) + 1;
            var pages_array = page_count > 0 ? range(1, page_count) : [];
            setPages(pages_array);
            setNext(data.next);
            setPrevious(data.previous);
            if (data.results)
                setUsers(data.results);
        });

        loadAudience(page,null,0).then(data => {
            setNotVerifiedCount(data.count)
        });

    }, []);

    function range(start, end) {
        return Array.apply(0, Array(end))
            .map((element, index) => index + start);
    }

    const handleDelete = (id, e) => {
        setLoading(id);
        deleteUser(id).then(data => {
            console.log(data)
            // loadUsers().then(users => {
            //     setUsers(users);
            // });
        })
    }

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete)
    }


    return (
        <>
            <div className="content-wrapper">
                <section className="content-header" style={{ maxWidth: '1550px' }}>
                    <h3 className="box-title mt-5"></h3>
                    <ol className="breadcrumb">
                        <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                        <li><a href="/cms/user"><i className="fa fa-user"></i> Users</a></li>
                        <li className="active">Audience</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="container-fluid" style={{ maxWidth: '1400px' }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-primary">
                                <div className="box-header with-border">
                                    <h3 className="box-title">
                                        All audience
                                        {count != null && (
                                            <span style={{ fontSize: 11, marginLeft: '0.35em' }}>({count})</span>
                                        )}
                                    </h3>
                                    <small className="color-grey"> <a href="audience?is_verified=1">Verified</a> , <a href="audience?is_verified=0">Not Verified</a> ({not_verified_count}) </small>
                                    <button type="button" title="Show Delete Button" className="btn btn-cm margin-r-5 pull-right" onClick={showDelete}>
                                        <i className="fa fa-trash"></i>
                                    </button>
                                    {filtered &&
                                        <a href="/cms/audience" type="button"
                                            className="btn btn-cm margin-r-5 pull-right">
                                            <i className="fa fa-reply"></i>
                                        </a>
                                    }
                                </div>
                                <div className="box-body no-padding">

                                    <table id="example1" className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{width:300}}>Name</th>
                                                <th>Status</th>
                                                <th>IP</th>
                                                <th>Registered</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users && users.map((item) => (
                                                <tr key={item.id} className={loading === item.id ? "loading" : ""}>
                                                    <td>
                                                        
                                                        <a href={`/cms/user/${item.id}`} className="link-color">
                                                            {item.first_name &&
                                                                <p className="text-capitalize mb-0 text-light">{item.first_name} {item.last_name}</p>
                                                            }
                                                            {!item.first_name &&
                                                                <p className="text-light">{item.email}</p>
                                                            }
                                                        </a>
                                                        
                                                    </td>
                                                    <td className="font-size-12">
                                                        <a href={`/cms/audience?is_verified=${item.is_verified ? 1 : 0}`}>
                                                            {item.is_verified ? "Verified" : "Not Verified"}
                                                        </a> 
                                                    </td>
                                                    <td>
                                                        <a href={`/cms/audience?ip=${item.ip}`}>
                                                            {item.ip}
                                                        </a> 
                                                       
                                                    </td>
                                                    <td className="font-size-12">
                                                        {item.created_at && item.created_at.split(' ')[0]} {item.created_at && item.created_at.split(' ').length > 1 && item.created_at.split(' ')[1].split('.')[0].split('+')[0]}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex" style={{ gap: '6px' }}>
                                                            {show_delete &&
                                                                <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-cm btn-sm">
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th>Name</th>
                                                <th>Status</th>
                                                <th>IP</th>
                                                <th>Registered</th>
                                                <th></th>
                                            </tr>
                                        </tfoot>
                                    </table>

                                </div>
                            </div>

                            <ul className="pagination cms-pagination m-0 float-right">
                                <li className="page-item"><Link className="page-link" to="#">«</Link></li>
                                {pages && pages.map((page_number) => (
                                    <li key={page_number} className="page-item">
                                        <a className={page_number == page ? "page-link active" : "page-link"} 
                                        href={`audience/${page_number}?is_verified=${is_verified}`}>{page_number}</a>
                                    </li>
                                ))}
                                <li className="page-item"><Link className="page-link" to="">»</Link></li>
                            </ul>

                        </div>

                    </div>
                    </div>

                </section>



            </div>
        </>



    )
}
